export const fmt = (n) => {
  const v = Number(n || 0);
  const hasCents = !Number.isInteger(v);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).format(v);
};

export const pct = (paid, original) => {
  if (!original || original <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round((paid / original) * 100)));
};
